import { ValueBasedTriggerType } from '@/enum/ValueBasedTriggerType'
import type { IValueBasedTrigger } from '@/interfaces/jobs/IValueBasedTrigger'

class ValueBasedTrigger implements IValueBasedTrigger {
  value: number
  type: ValueBasedTriggerType
  endAt?: number | undefined
  numberOfOccurrences?: number | undefined

  constructor(valueBasedTrigger?: any) {
    this.value = valueBasedTrigger?.value
    this.type = valueBasedTrigger?.type ?? ValueBasedTriggerType.AtValue
    this.numberOfOccurrences = valueBasedTrigger?.numberOfOccurrences
    this.endAt = valueBasedTrigger?.endAt
  }
}

export default ValueBasedTrigger
